import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetMarkFileListService } from './api-services/get-mark-file-list.service';
import { RegistMarkFileService } from './api-services/regist-mark-file.service';

import { KYMW1504Component } from './kymw1504.component';

/**
 * マーク登録画面 モジュール設定クラス
 *
 * @export KYMW1504Module
 * @class KYMW1504Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW1504Component,
  ],
  providers: [
    GetMarkFileListService,
    RegistMarkFileService
  ],
})
export class KYMW1504Module {
}
